// @ts-strict-ignore
import { component } from "picoapp";

export const reviewsSummary = component((node) => {
  const readMoreReviewsButton = node.querySelector(
    "#read-more-reviews-container button"
  );
  const readMoreReviewsButtonContainer = node.querySelector(
    "#read-more-reviews-container"
  );
  const reviewsCount =
    document.querySelector<HTMLSpanElement>("#reviews-count");
  const reviewsWidget =
    document.querySelector<HTMLElement>(".yotpo-main-widget");
  const productId = reviewsCount.dataset.productId;

  const newReviewsSection = document.querySelector(`#reviews-for-${productId}`);
  if (!reviewsWidget && !newReviewsSection) {
    readMoreReviewsButtonContainer.classList.add("hidden");
  }

  const populateTotalReviewsText = async () => {
    const yotpoId = reviewsCount.dataset.yotpoId;
    if (yotpoId && productId) {
      const data = await fetch(
        `https://api.yotpo.com/products/${yotpoId}/${productId}/bottomline`
      )
        .then((res) => res.json())
        .catch((e) => console.error(e));

      if (data?.response) {
        const totalReviews = data?.response?.bottomline?.total_reviews;
        reviewsCount.innerHTML = `(${totalReviews.toLocaleString()})`;
      }
    }
  };

  if (reviewsCount) {
    const isAggregate = node.dataset.isAggregate;
    if (isAggregate && isAggregate !== "true")
      requestIdleCallback(() => populateTotalReviewsText());
  }

  const handleReadMoreReviewsButtonClick = function (e) {
    e.preventDefault();

    if (newReviewsSection) {
      newReviewsSection.scrollIntoView({ behavior: "smooth" });
      return;
    }

    window.scrollTo({
      behavior: "smooth",
      top:
        reviewsWidget.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top,
    });

    reviewsWidget.focus();
  };

  readMoreReviewsButton.addEventListener(
    "click",
    handleReadMoreReviewsButtonClick
  );

  return () => {
    readMoreReviewsButton.removeEventListener(
      "click",
      handleReadMoreReviewsButtonClick
    );
  };
});
